import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import HomePage from '@/pages/HomePage';
import EventDetails from '@/pages/events/pages/EventDetails';
import SubcategoryPage from '@/pages/events/pages/SubcategoryPage';
import ArtistPage from '@/pages/ArtistPage';
import TicketSelection from '@/pages/events/pages/TicketSelection';
import SeatSelection from '@/pages/events/pages/SeatSelection';
import BookingPage from '@/pages/events/pages/BookingPage';
import BookingConfirmationPage from '@/pages/events/pages/BookingConfirmationPage';
import VenueDetails from '@/pages/VenueDetails';
import BookingDetails from '@/pages/BookingDetails';
import MyBookings from '@/pages/MyBookings';
import SupportList from '@/pages/support/SupportList';
import SupportCase from '@/pages/support/SupportCase';
import Offers from '@/pages/Offers';
import Team from '@/pages/Team';
import Contact from '@/pages/Contact';
import DeleteAccount from '@/pages/DeleteAccount';
import Terms from '@/pages/Terms';
import Privacy from '@/pages/Privacy';
import NotFound from '@/pages/NotFound';
import CmsPage from '@/pages/CmsPage';
import AuthModal from '@/components/AuthModal';
import ScrollToTop from '@/components/ScrollToTop';
import AnalyticsTracker from '@/components/AnalyticsTracker';
import { AuthProvider } from '@/context/AuthContext';
import { EventProvider } from '@/context/EventContext';
import { SiteContentProvider, SeoManager } from '@/lib/siteContent';

function App() {
  return (
    <AuthProvider>
      <EventProvider>
        <SiteContentProvider>
        <Router>
          <div className="min-h-screen bg-surface-muted">
            <ScrollToTop />
            <AnalyticsTracker />
            <SeoManager />
            <Routes>
              <Route path="/" element={<HomePage />} />
              {/* Browse-by landing page, one per admin-configured sub-category. */}
              <Route path="/events/:slug" element={<SubcategoryPage />} />
              <Route path="/event/:id" element={<EventDetails />} />
              <Route path="/venue/:id" element={<VenueDetails />} />
              <Route path="/artist/:slug" element={<ArtistPage />} />
              <Route path="/tickets/:id" element={<TicketSelection />} />
              <Route path="/seat-selection/:id" element={<SeatSelection />} />
              <Route path="/book/:id" element={<BookingPage />} />
              <Route path="/booking/confirmation" element={<BookingConfirmationPage />} />
              <Route path="/booking/:id" element={<BookingDetails />} />
              <Route path="/my-bookings" element={<MyBookings />} />
              <Route path="/support" element={<SupportList />} />
              <Route path="/support/:id" element={<SupportCase />} />
              <Route path="/offers" element={<Offers />} />
              <Route path="/team" element={<CmsPage slug="team" fallback={<Team />} />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/delete-account" element={<DeleteAccount />} />
              {/* Admin-published pages win; the old hardcoded page is the fallback. */}
              <Route path="/terms" element={<CmsPage slug="terms" fallback={<Terms />} />} />
              <Route path="/privacy" element={<CmsPage slug="privacy" fallback={<Privacy />} />} />
              <Route path="/p/:slug" element={<CmsPage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <AuthModal />
            <Toaster position="top-center" toastOptions={{ duration: 3000 }} />
          </div>
        </Router>
        </SiteContentProvider>
      </EventProvider>
    </AuthProvider>
  );
}

export default App;
